function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent } from "react";
import propTypes from "prop-types";
import Carousel from "../../../../carousel";
import { context } from "../../../../wr-context";
import Product from "../../../list/product";
import { uniq, flatten } from "lodash";
import connectRequest from "../../../../../utils/connect-request";
import request from "../../../../../utils/request";
import i18n from "../../../../../utils/i18n";
import { fetchProductById } from "../../../../../modules/product/product-requests";
import Label from "../../../../label";
var BundlesComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(BundlesComponent, PureComponent);
    var _super = _createSuper(BundlesComponent);
    function BundlesComponent() {
        _classCallCheck(this, BundlesComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.renderProduct = function(id) {
            var productsRequest = _this.props.productsRequest;
            var product = productsRequest.value.find(function(v) {
                return v.id === id;
            });
            if (!product) {
                return null;
            }
            return /*#__PURE__*/ React.createElement(Product, {
                key: id,
                product: product,
                categoryClassNameMapping: [],
                configureButtonLabel: i18n("productList.configure")
            });
        };
        return _this;
    }
    var _proto = BundlesComponent.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, row = _props.row, productsRequest = _props.productsRequest;
        var bundles = (row.options || {}).bundles;
        if (productsRequest.pending || !productsRequest.fulfilled) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", null, bundles === null || bundles === void 0 ? void 0 : bundles.map(function(v) {
            return /*#__PURE__*/ React.createElement("div", {
                key: v.id
            }, context.constants.product.bundles.renderName && v.name && /*#__PURE__*/ React.createElement(Label, null, v.name), /*#__PURE__*/ React.createElement(Carousel, null, v.childIds.map(_this.renderProduct)));
        }));
    };
    return BundlesComponent;
}(PureComponent);
BundlesComponent.propTypes = {
    row: propTypes.object.isRequired,
    productsRequest: propTypes.object.isRequired
};
export default connectRequest(function(props) {
    var row = props.row;
    var bundles = (row.options || {}).bundles;
    var productIds = uniq(flatten((bundles || []).map(function(v) {
        return v.childIds;
    })));
    return {
        productsRequest: {
            value: Promise.all(productIds.map(function(id) {
                return request(fetchProductById(id)).then(function(param) {
                    var data = param.data;
                    return data;
                });
            })),
            comparison: productIds.slice().sort().join("")
        }
    };
})(BundlesComponent);
